import { createContext } from 'react';
import { ParametersEnum } from 'pages/dimensions/types';
import { TApi } from 'utils/api';

export type TProjectConfigurationParameter = {
  key: string;
  value: string;
};

export interface TSurfaceItem {
  inputParameters: TInputParams;
  enums: {
    baseSurface?: {
      [key: string]: number;
    };
    typeInstallation?: {
      [key: string]: number;
    };
  };
}

export interface TExtendedSurfaceItem extends TSurfaceItem {
  name: 'wall' | 'ceiling' | 'floor';
  label: string;
  materialLabel: string;
  materials: Array<{ name: string; label: string }>;
  typeInstallation?: {
    [key: string]: number;
  };
}

export interface Surface {
  [key: string]: TSurfaceItem;
}

export type TInputParams = Array<ParametersEnum>;

export type MeasurementServices = {
  name: string;
  priceMin: number;
  serviceURL: string;
  type: string;
};

export interface TData {
  productId: string;
  displayedName: string;
  photo: string;
  mainPrice: number;
  additionalPrice: number;
  additionalAsMain?: boolean;
  mainUomRus: string;
  additionalUomRus: string;
  projectConfigurationParameters: Array<TProjectConfigurationParameter> | null;
  surfaces: {
    surface: Surface;
    complimentaryProducts: string[];
    id: string;
    services?: MeasurementServices[];
  };
  currentRoute: string;
  isSurfaceOne: boolean;
  env: {
    ORCHESTRATOR_HOST: string;
    BASKET_URL: string;
    API_KEY: string;
  };
  api: TApi;
  regionId: string;
}

type TRouteContext = {
  context: string | null;
  setContext: React.Dispatch<React.SetStateAction<string>>;
};

export const DataContext = createContext<TData | null>(null);
export const RouteContext = createContext<TRouteContext>({
  context: null,
  setContext: () => {
    // empty initial function
  },
});
